// Shared content data: blog posts. Used across landing + dedicated pages.

export const BLOG_POSTS = [
    {
        slug: "stop-posting-everything",
        title: "Stop trying to be everywhere. Be excellent somewhere.",
        excerpt:
            "The fastest way to grow as a small business online is to pick one channel and commit. Here's how to choose — and what to do once you have.",
        category: "Strategy",
        readingTime: "5 min",
        date: "2026-04-22",
        author: "The Simple Digital crew",
        body: [
            "Every other week we meet a small business owner trying to post on Instagram, TikTok, Facebook, LinkedIn and Pinterest — and tired beyond belief.",
            "Here's the truth: being on five platforms badly doesn't beat being on one platform brilliantly. The algorithm rewards depth, not breadth. So does your future customer.",
            "**How to pick your one channel.** Ask three questions:",
            "1. Where does your customer already scroll? (Instagram for visual / lifestyle, TikTok for younger or behind-the-scenes, LinkedIn for B2B, Facebook for community-driven local businesses.)",
            "2. What can you sustainably make? (If you hate being on camera, picking TikTok will hurt you.)",
            "3. Where are your competitors absent? (Goldmine.)",
            "**Then commit for 90 days.** Three posts a week. Reply to every comment within 12 hours. Show up like a human. Watch what happens.",
            "**What about the others?** Cross-post when it makes sense. But don't measure them. Don't sweat them. They're a bonus, not a job.",
            "The brands that win small are the ones that pick a lane and stay in it long enough for compounding to do its thing. That's it. That's the secret.",
        ],
    },
    {
        slug: "captions-that-convert",
        title: "The 3-line caption that gets DMs every time",
        excerpt:
            "Hook → value → ask. A simple caption formula we use for every client. With three real examples.",
        category: "Copywriting",
        readingTime: "4 min",
        date: "2026-03-18",
        author: "The Simple Digital crew",
        body: [
            "Most small-business captions read like a Hallmark card pinned to a press release. They're nice. They don't sell.",
            "The structure we use for every client is brutally simple: **hook, value, ask**. Three lines. Done.",
            "**Hook (line 1).** A question, a contrarian take, a specific number. Whatever stops the thumb.",
            "**Value (line 2).** One specific insight, story, or tip — not a sales pitch.",
            "**Ask (line 3).** One clear next step. Comment, save, DM, book — pick one.",
            "**Example: café.** \"Why we charge $5.50 for a flat white. (It's not the milk.) Save this if you want a 30-second crash course in how a café actually makes money. DM us 'menu' for our hidden lunch set.\"",
            "**Example: builder.** \"Did your builder text you back today? Most don't. Here's why we built our quote response into the working day. Tap follow if you want straight answers, fast.\"",
            "**Example: yoga studio.** \"This is the move that fixed my dodgy shoulder. 20 seconds, twice a day. Save it for tomorrow morning — and tell us how you feel by Friday.\"",
            "Try it tomorrow. We bet your engagement jumps by Wednesday.",
        ],
    },
    {
        slug: "diy-content-day",
        title: "How to shoot a month of content in one afternoon",
        excerpt:
            "You don't need a camera, a studio, or 'aesthetic'. Just a phone, a window, and 90 minutes.",
        category: "Content",
        readingTime: "6 min",
        date: "2026-02-09",
        author: "The Simple Digital crew",
        body: [
            "Batching is the single biggest unlock for small business owners who hate making content. Here's how we coach clients through it.",
            "**Block 90 minutes.** Pick a Sunday morning when the shop is closed and the light is good.",
            "**Prep a shot list.** 12 photos + 6 short clips. Write it on paper, in plain words: 'the team laughing', 'the muffin on the cooling rack', 'the front door opening', 'me explaining what we do'.",
            "**Find one good window.** Natural light is free and beats every ring light. Shoot with your back to the window, subject facing it.",
            "**Use Notes for captions.** Open one note. Dump every caption idea you've had this week. You'll write three from it later.",
            "**Save to one folder.** Google Drive, Dropbox, your phone's 'favourites' — anywhere you'll find it again. Don't trust your camera roll.",
            "**Schedule, don't post.** Use Meta Business Suite (free) or any scheduler. Schedule 12 posts over the next four weeks while the shots are fresh.",
            "That's it. One Sunday afternoon = a month of content. Now you can spend your week running the business — not chasing posts.",
        ],
    },
    {
        slug: "owning-your-list",
        title: "Why your email list will outlive every social platform",
        excerpt:
            "Followers are rented. Subscribers are owned. Here's how to build a list from scratch — slowly, ethically, and well.",
        category: "Email",
        readingTime: "5 min",
        date: "2026-01-15",
        author: "The Simple Digital crew",
        body: [
            "Algorithms change. Platforms die. Vibes shift. The thing that doesn't change is the inbox.",
            "Email is the most-undervalued tool small businesses have — and it's the one you actually own.",
            "**Start tiny.** A free Mailchimp or Brevo account is enough for the first 500 subscribers. Don't over-think it.",
            "**Give a reason.** Nobody signs up for 'updates'. They sign up for a 10% welcome offer, a free guide, or insider access. Lead with that.",
            "**Capture everywhere.** Add a sign-up form on your homepage, in your footer, in your receipts, after every sale. Each touchpoint compounds.",
            "**Send something.** A short welcome email. A monthly note. A flash sale on a slow Tuesday. Whatever you do, do it consistently. The list that gets emailed is the list that pays you back.",
            "**Don't buy lists.** Ever. It's spammy, it's illegal in NZ and AU, and it'll burn your deliverability for years.",
            "If you do nothing else this quarter, start the list. Future you will be very, very glad.",
        ],
    },
];
